<template>
  <div id="app" class="desktop">
    <router-view></router-view>
    <div v-if="showIntro" class="intro-container">
      <div class="intro-title"></div>
      <div class="intro">
        <div class="intro-1"></div>
        <div class="intro-2"></div>
        <div class="intro-3"></div>
        <div class="intro-4"></div>
        <div class="intro-5"></div>
        <div class="intro-6"></div>
        <div class="intro-7"></div>
        <div class="intro-8"></div>
        <div class="intro-9"></div>
        <div class="intro-10"></div>
        <div class="intro-11"></div>
        <div class="intro-12"></div>
      </div>
    </div>
    <div v-show="!showIntro" class="container-fluid desktop" :class="{ 'fade-in': !showIntro }" id="fadingDiv">
      <div class="col-xs-12 text-center home-header">
			  <h1>Design Your Cambro Tray</h1>
		  </div>
		  <div class="cleaner"></div>
		  <div class="home-body home">
			<div class="row-flex">
				<div class="home-tray">
					<h2>Rectangular Trays</h2>
					<h3>The Classic Canvas</h3>
					<div class="row">
						<div class="col-lg-6">
							<a href="https://cambro.com/traydesigner/rectangular-trays" rel="noopener noreferrer" target="_parent"><img src="images/home_rectangular.png" width="100%" /></a>
						</div>
						<div class="col-lg-6 home-copy">
							<p>Choose from our classic Camtrays, durable Fast Food Trays, the new Décor Series, and more to create a design that's uniquely yours. Each tray is a blank slate waiting for your personal touch.</p>
							<a href="https://cambro.com/traydesigner/rectangular-trays" rel="noopener noreferrer" target="_parent"><button>Personalize <div class="angle">&rsaquo;</div></button></a>
						</div>
					</div>
					
				</div>
				<div class="home-tray">
					<h2>Round Trays</h2>
					<h3>Circle of Perfection</h3>
					<div class="row">
						<div class="col-lg-6">
							<a href="https://cambro.com/traydesigner/round-trays" rel="noopener noreferrer" target="_parent"><img src="images/home_round.png" width="100%" /></a>
						</div>
						<div class="col-lg-6 home-copy">
							<p>Discover the elegance of curves with our Round Trays, available in both Camtrays and Camtread options. Camtrays offer a smooth canvas for your vibrant designs, while Camtread trays blend style with slip-resistant practicality. Each serves up a perfect circle of possibilities for showcasing your brand or personal flair.</p>
							<a href="https://cambro.com/traydesigner/round-trays" rel="noopener noreferrer" target="_parent"><button>Personalize <div class="angle">&rsaquo;</div></button></a>
						</div>
					</div>
					<div class="cleaner"></div>
				</div>
				
					<div class="home-tray">
						<h2>Trapezoid Trays</h2>
						<h3>Fit for Any Space</h3>
						<div class="row">
							<div class="col-lg-6">
								<a href="https://cambro.com/traydesigner/trapezoid" rel="noopener noreferrer" target="_parent"><img src="images/home_trapezoid.png" width="100%" /></a>
							</div>
							<div class="col-lg-6">
								<p style="text-align: left;">Step outside the rectangle with our Trapezoid Trays, designed to fit any setting with flair. Ideal for educational settings or maximizing table space, these trays offer a distinctive shape that's as functional as it is stylish. Personalize with school colors, mascots, or your cafe's branding to make every meal an experience.</p>
								<a href="https://cambro.com/traydesigner/trapezoid" target="_parent"><button>Personalize <div class="angle">&rsaquo;</div></button></a>
							</div>
						</div>
					</div>
				
					<div class="home-tray">
						<h2>Compartment Trays</h2>
						<h3>Perfect Portions, Perfectly Served</h3>
						<div class="row">
							<div class="col-lg-6">
								<a href="https://cambro.com/traydesigner/compartment-trays" rel="noopener noreferrer" target="_parent"><img src="images/home_school-tray.png" width="100%" /></a>
							</div>
							<div class="col-lg-6">
								<p style="text-align: left;">Tailor-made for educational settings, our Compartment Trays bring order and personality to every meal. While perfect for portion control, these trays offer prime space for a logo or emblem, allowing schools to add a touch of spirit to dining. Whether it's a school crest or a simple, elegant logo, these trays are built to combine functionality with a personalized flair.</p>
								<a href="https://cambro.com/traydesigner/compartment-trays" rel="noopener noreferrer" target="_parent"><button>Personalize <div class="angle">&rsaquo;</div></button></a>
							</div>
						</div>
					</div>
				
			</div>
		  </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import '../assets/intro.css';

export default {
  name: 'Home',
  setup() {
    const showIntro = ref(true);

    onMounted(() => {
      const imagesToPreload = ['images/intro/red.png', 'images/intro/red2.png', 'images/intro/design.png'];
      imagesToPreload.forEach(imageSrc => {
        const img = new Image();
        img.src = imageSrc;
      });
      
      setTimeout(() => {
        showIntro.value = false;
      }, 6000); // Adjust this time to match your animation duration
    });

    return {
      showIntro
    };
  }
}
</script>

<!-- <style scoped>
.intro-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
}

#fadingDiv {
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

#fadingDiv.fade-in {
  opacity: 1;
}
</style> -->